import { Button } from '@app/components/various/Button';
import { FocusTrap } from '@app/components/various/FocusTrap';
import { CancelSmall } from '@app/components/various/Icons';
import { Portal } from '@app/components/various/Portal';
import { Scrim } from '@app/components/various/Scrim';
import { cn } from '@app/utils/cn';
import { useBodyLock } from '@app/utils/hooks/useBodyLock';
import { isDefined } from '@app/utils/is';
import cx from 'classnames';
import { PropsWithChildren } from 'react';
import { CSSTransition } from 'react-transition-group';

import { DatePickerInputs } from './DatePickerInputs';

interface Props {
  isVisible: boolean;
  onVisibilityChange: (value: boolean) => void;
  titleMobile?: string;
  dataTestId?: string;
  placeholder: string;
}

export const DatePickerDrawer = ({
  dataTestId,
  placeholder,
  isVisible,
  onVisibilityChange,
  children,
  titleMobile,
}: PropsWithChildren<Props>) => {
  useBodyLock(isVisible);

  return (
    <Portal>
      <Scrim isVisible={isVisible} onClick={() => onVisibilityChange(false)} />
      <CSSTransition
        timeout={{
          enter: 250,
          exit: 150,
        }}
        in={isVisible}
        classNames={{
          enter: 'opacity-0 translate-y-[10px]',
          enterActive: '!opacity-100 !translate-y-0 transition-[opacity,transform] delay-100',
          exit: 'opacity-100',
          exitActive: '!opacity-0 transition-[opacity,transform]',
        }}
        unmountOnExit
      >
        <div className={cx('fixed bottom-0 z-drawer flex w-full min-w-64 justify-center rounded-t-regular bg-white px-4 py-5')}>
          <FocusTrap>
            <div className="flex w-full flex-col-reverse">
              <div>
                <DatePickerInputs dataTestId={dataTestId} placeholder={placeholder} withinDrawer onVisibilityChange={onVisibilityChange} />
                {children}
              </div>
              <div
                className={cn('flex items-center justify-end pb-1', {
                  'justify-between': isDefined(titleMobile),
                })}
              >
                {isDefined(titleMobile) && <h3 className="heading-3">{titleMobile}</h3>}
                <Button icon={CancelSmall} size="medium" variant="ghost" color="secondary" onClick={() => onVisibilityChange(false)} />
              </div>
            </div>
          </FocusTrap>
        </div>
      </CSSTransition>
    </Portal>
  );
};
